<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    functional: true,
    props: {
      show: { type: undefined, default: false },
    },
    render(h: any, context: any) {
      const { children, props } = context;

      if (props.show) {
        return children;
      }
      return children
        .map((child: any) => {
          if (child.children) return child.children;
          return child.componentOptions != null ? child.componentOptions.children : null;
        })
        .filter((list: any) => list); // remove any null and void
    },
  });
</script>
